import ResponsiveSwitch from "../../../../../../packages/design-system/src/ResponsiveSwitch";
import Spacings from "../../../../../../packages/design-system/src/Spacings";
import Text from "../../../../../../packages/design-system/src/Text";
import * as React from 'react';
export default {
  ResponsiveSwitch,
  Spacings,
  Text,
  React
};